// extracted by mini-css-extract-plugin
export var body = "q1M4DRqTt0iv5R3dpIm0";
export var fontBold = "F4HCfuO8_3gUO0k8l72V";
export var fontMedium = "CZUWk29o1OfkxJORawUY";
export var fontRegular = "E3K7Z6TZaHdOHMYhfqRw";
export var large = "TlxAsrUt93Lx5rtL3lX3";
export var micro = "r4sGqhxIBAuIBoMK4mIN";
export var mini = "hxkX2D8H2kQqWjwugOXX";
export var root = "R9bUKUVC2Futm9dQIdpN";
export var small = "AiFNeKalb97jl1RMCQg2";